/**
 * @fileoverview サインインコールバック処理ページ
 *
 * このファイルでは、外部認証サービス（OAuth、OIDC等）からの
 * コールバック処理を行うページを定義しています。認証レスポンスを
 * 受け取り、トークンの検証・保存やユーザー情報の取得を行います。
 */

/**
 * サインインコールバックページコンポーネント
 *
 * 外部認証サービスからのリダイレクト後に実行される処理を管理します。
 * URLパラメータから認証情報を抽出し、バックエンドAPIと連携して
 * 認証プロセスを完了させます。認証の成功・失敗に応じて適切なページに
 * ユーザーをリダイレクトします。
 *
 * @returns {JSX.Element} コールバック処理中の表示またはリダイレクト
 */
import { useEffect, useContext } from "react";
import { useLocation } from "react-router";
import { useNavigate } from "@/router";
import { CsrfTokenContext } from "@/providers/csrfToken/context";
import { loginCallback } from "@/api/loginCallback";
import { LoadingOverlay } from "@mantine/core";
import { Card } from "@/components/card";

export default function SigninCallback() {
  const search = useLocation().search;
  const queries = new URLSearchParams(search);
  const code = queries.get("code");
  const state = queries.get("state");

  if (!code || !state) {
    console.error("Code or State is not found.");
    return;
  }

  const csrfTokenContext = useContext(CsrfTokenContext);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      await loginCallback(state, code);
      await csrfTokenContext.issueCsrfToken();
      if (!csrfTokenContext.loading && !csrfTokenContext.error) {
        navigate("/user");
      }
    })();
  }, []);

  return (
    <Card title="サインイン中" description="しばらくお待ちください。">
      <LoadingOverlay
        visible={true}
        overlayProps={{ blur: 0 }}
        loaderProps={{ type: "dots", color: "#3182ce", size: "xl" }}
      />
    </Card>
  );
}
